import styles from './background.module.css'

type Props = {
  isHomepage?: boolean,
}

const Background = ({ isHomepage }: Props) =>
  // <div className={styles.background}>
  //   <img className={styles.backgroundImage} src='/static/images/background/hustle-2400.jpeg' />
  // </div>
  <div className={isHomepage ? styles.homepageBackground : styles.background} />

export default Background
